export default __webpack_public_path__ + "static/media/yueko.c9cbcab4.jpg";